<svg
     [attr.width]="svgSize()"
     [attr.height]="svgSize()"
     [attr.viewBox]="viewBox()"
     xmlns="http://www.w3.org/2000/svg"
     preserveAspectRatio="xMidYMid meet"
>
<defs>
       @if (outerStrokeGradient()) {
<linearGradient [id]="gradientId">
<stop offset="5%"  [attr.stop-color]="outerStrokeColor()" stop-opacity="1" />
<stop offset="95%" [attr.stop-color]="outerStrokeGradientStopColor()" stop-opacity="1" />
</linearGradient>
       }
</defs>
<!-- Inner Circle -->
<circle
       [attr.cx]="center()"
       [attr.cy]="center()"
       [attr.r]="radius()"
       fill="none"
       [attr.stroke]="innerStrokeColor()"
       [attr.stroke-width]="innerStrokeWidth()"
     />
<!-- Outer Progress Arc (ใช้ animatedPercent แทน percent โดยตรง) -->
     @if (animatedPercent() > 0) {
<path
         [attr.stroke]="outerStrokeGradient() ? 'url(#' + gradientId + ')' : outerStrokeColor()"
         [attr.d]="arcPath()"
         [attr.stroke-width]="outerStrokeWidth()"
         stroke-linecap="round"
         fill="none"
       />
     }
<!-- Title -->
     @if (showTitle()) {
<text
         [attr.x]="center()"
         [attr.y]="titleY()"
         text-anchor="middle"
         dominant-baseline="middle"
         [attr.font-size]="titleFontSize()"
         [attr.font-weight]="titleFontWeight()"
         [attr.fill]="titleColor()"
>{{ titleText() }}</text>
     }
<!-- Subtitle -->
     @if (showSubtitle()) {
<text
         [attr.x]="center()"
         [attr.y]="subtitleY()"
         text-anchor="middle"
         dominant-baseline="middle"
         [attr.font-size]="subtitleFontSize()"
         [attr.fill]="subtitleColor()"
>{{ subtitle() }}</text>
     }
</svg>